import { render } from "./RegForm.vue?vue&type=template&id=172eb60a"
import script from "./RegForm.vue?vue&type=script&lang=js"
export * from "./RegForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__